import { useLanguage } from "../../../../contexts/LanguageContext"

/**
 * Step-by-step navigation actions component.
 * Renders navigation buttons (previous, next, done) and "do not show again" checkbox.
 * @param {Object} props
 * @param {Object} props.parameters - Configuration parameters for button labels
 * @returns {JSX.Element}
 */
export default function StepActions({ parameters }) {
  const { t } = useLanguage()

  return (
    <div>
      <div className="circle-effect">
        <span className="hopscotch-bubble-close hopscotch-close" data-testid="hopscotch-bubble-close"></span>
      </div>
      <div className="hopscotch-actions">
        <button className="hopscotch-nav-button hopscotch-prev" data-testid="hopscotch-prev"></button>
        <button id="calloutNextBtn" className="hopscotch-nav-button hopscotch-button hopscotch-next" data-testid="calloutNextBtn">
          {parameters.calloutNextBtn || t("Text.textNextButtonInput")}
        </button>
        <button className="hopscotch-nav-button hopscotch-button hopscotch-done" data-testid="hopscotch-done">
          {parameters.calloutDoneBtn || t("Text.textCloseButtonInput")}
        </button>
      </div>
      <div className="hopscotch-do-not-show">
        <label>
          <input type="checkbox" />
          <span>{parameters.doNotShowAgainLabel || t("Text.textDoNotShowAgainMessageInput")}</span>
        </label>
      </div>
    </div>
  )
}
